import { memo, useCallback, useState, useEffect } from 'react';
import { cn, Price } from '@divlab/divanui';

import * as ApiPecom from '@Api/Pecom';
import { useDeps } from '@Contexts/DI';
import CustomYMaps from '@Components/CustomYMaps';
import useTranslation from '@Queries/useTranslation';
import PecomMapPlacemark from '@Components/PecomMapPlacemark';
import styles from './PickupPoint.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface PickupPointProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  region: string;
}

const PickupPoint: FC<PickupPointProps> = (props) => {
  const { className, region, ...restProps } = props;
  const { logger } = useDeps();
  const [pickupPoints, setPickupPoints] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const { t } = useTranslation();

  const loadWarehouses = useCallback(async () => {
    try {
      const warehouses = await ApiPecom.getWarehouses({ city: region });
      const sellPoints = warehouses.map((item) => ({
        ...item,
        coordinates: [item.coordinates.latitude, item.coordinates.longitude],
      }));

      setPickupPoints(sellPoints);
    } catch (err) {
      logger.log(err);
    } finally {
      setLoaded(true);
    }
  }, [region, logger]);

  // Загружаем список пунктов выдачи
  useEffect(() => {
    loadWarehouses();
  }, [loadWarehouses]);

  return (
    <div {...restProps} className={cn(styles.container, className)}>
      <div className={styles.text}>
        {t('pickuppoint-text.1')} &quot;{t('pickuppoint-text.pek')}&quot;.
      </div>
      <div className={styles.text}>
        {t('pickuppoint-text.2')}
        <Price className={styles.price} price={1000} />
      </div>
      <div className={styles.mapTitle}>{t('pickuppoint-text.adresses')}</div>
      {loaded && pickupPoints.length > 0 ? (
        <CustomYMaps
          className={styles.map}
          sellPoints={pickupPoints}
          renderItem={(placemarkProps) => <PecomMapPlacemark {...placemarkProps} />}
        />
      ) : (
        <div className={styles.map} />
      )}
    </div>
  );
};

export default memo(PickupPoint);
